
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSlightlycloudyNight as ObiSlightlycloudyNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-slightlycloudy-night.js';
 
 
 

 
 export const ObiSlightlycloudyNight = createComponent({
   react: React,
   tagName: 'obi-slightlycloudy-night',
   elementClass: ObiSlightlycloudyNightElement,
   events: {
     
   }
  });
 
 